// extracted by mini-css-extract-plugin
export default {"header":"contact-details-edit_header__1+loY","container":"contact-details-edit_container__1kYkX"};